import { createSelector } from 'reselect';
import getBookingPackageOptions from './getBookingPackageOptions';

const getBookingPackageOption = createSelector(
  (state, bookingReference) =>
    getBookingPackageOptions(state, bookingReference),
  (state, bookingReference, handle) => handle,

  (options, handle) =>
    options?.find(({ handle: optionHandle }) => optionHandle === handle)
      ?.value ?? null,
);

export default getBookingPackageOption;
